import React from "react";
import Image from "./Component/Image";
import Gooup from "./Component/Gooup";

function App() {
 
  return (
    <div >
      <Image/>
    </div>
  );
}

export default App;
